import React from "react";
import { Link } from "react-router-dom";

import "./Header.css";
import logo from "./assets/logo-lr.svg";
import useLang from "../../i18n/useLang";
import { pathFor } from "../../i18n/routes";
import { demoUrl } from "../../i18n/links";
import LangSwitch from "./LangSwitch";

const CONTENT = {
  fr: {
    cta: "Découvrir Localranker",
  },
  en: {
    cta: "Discover Localranker",
  },
};

const Header = () => {
  const lang = useLang();
  const t = CONTENT[lang];

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <Link to={pathFor("home", lang)} className="navbar__logo">
          <img src={logo} alt="Localranker" />
          <span className="navbar__tag">tools</span>
        </Link>
        <div className="navbar__actions">
          <LangSwitch />
          <a
            className="navbar__cta"
            href={demoUrl(lang, "header")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t.cta}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
